const STORAGE_KEY = 'gamesHubRecent';
const MAX_RECENT = 6;

export function recordRecentGame(gameId, title) {
  if (!gameId) return;
  try {
    const existing = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    const filtered = existing.filter((item) => item.id !== gameId);
    const next = [{ id: gameId, title: title || gameId, playedAt: Date.now() }, ...filtered].slice(0, MAX_RECENT);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* ignore storage errors */
  }
}

export function getRecentGames() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}
